// extracted by mini-css-extract-plugin
export var content = "_8l-3";
export var list = "_8l-4";
export var settingsContent = "_8l-7";
export var settingsPanel = "_8l-8";
export var state = "_8l-6";
export var triggerBadge = "_8l-2";
export var triggerButton = "_8l-1";
export var triggerShell = "_8l-0";
export var unreadDot = "_8l-5";